import {CreateInstance} from './config'
const ApprovalExcelUploadAPI = CreateInstance('ApprovalExcelUpload')
export default ApprovalExcelUploadAPI
